export default {
  computed: {
    getIsLogin() {
      return this.$store.getters["auth/getPlayerId"] ? true : false;
    },
  },
  methods: {
  },
};
